<!--
 * @Description: 业务区域 弹窗统一处理
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-05-19 17:31:37
 * @FilePath: \YunYin_admin\src\views\Cooperative\Management\changeDialog.vue
-->
<template>
  <div class="change-dialog">
    <el-dialog
      class="dialog-selCooper"
      title="更换业务区域或业务员"
      :visible.sync="showDialog"
      width="400"
      :before-close="close"
    >
      <el-form :model="currentForm" :rules="currentRules" ref="currentForm">
        <el-form-item class="change-item"
          >已选{{
            dataList.length
          }}条数据，请选择更换的业务区域及业务员。</el-form-item
        >
        <el-form-item label="业务区域：" label-width="90px">
          <el-select
            style="text-overflow: ellipsis"
            ref="selectTree"
            v-model.trim="currentForm.businessZoneId"
            placeholder="请选择所属区域"
            popper-class="select-tree"
          >
            <el-option
              :value="node.id"
              :key="node.id"
              :label="node.zoneName"
              style="height: auto"
            >
              <el-tree
                ref="selectedTree"
                :data="businessZoneList"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                :current-node-key="node.id"
                :props="{
                  children: 'children',
                  label: 'zoneName',
                }"
                @node-click="handleOptionClick"
              />
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务负责人：" label-width="107px">
          <el-select
            v-model.trim="currentForm.businessPersonId"
            placeholder="请选择业务负责人"
          >
            <el-option
              v-for="item in optionPersonList"
              :key="item.id"
              :label="item.personName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 底部按钮 -->
        <el-form-item class="foot-btns">
          <el-button type="primary" class="btn-cancel" @click="close"
            >取消</el-button
          >
          <el-button
            type="primary"
            class="btn-confirm"
            @click="confirmCurrent()"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ChangeDialog",
  props: {
    // 弹窗是否显示
    showDialog: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => "coo",
    },
  },
  data() {
    return {
      currentForm: { businessZoneId: "", businessPersonId: "" }, // 当前表单提交参数
      currentRules: {}, // 当前表单验证
      node: {}, // 选中区域数据
      businessZoneList: [], // 区域数据
      optionPersonList: [], // 业务员列表
    };
  },
  computed: {},
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-13 14:19:50
     */
    close() {
      this.$emit("close");
    },
    /**
     * @description: 保存当前表单
     * @Author: yangsibo
     * @Date: 2022-05-13 08:50:05
     */
    confirmCurrent() {
      if (!this.currentForm.businessZoneId) {
        this.$message({
          type: "warning",
          message: "请选择业务区域",
          duration: 2000,
        });
        return false;
      }
      if (!this.currentForm.businessPersonId) {
        this.$message({
          type: "warning",
          message: "请选择业务员",
          duration: 2000,
        });
        return false;
      }
      this.currentForm.ids = this.dataList.map((val) => {
        return val.id;
      });
      this.updateCustomer(this.currentForm);
    },
    /**
     * @description: 更换区域和业务员
     * @Author: yangsibo
     * @Date: 2022-05-16 15:43:38
     * @param {*} params 参数
     * @return {*}
     */
    async updateCustomer(params) {
      try {
        let { status } = await this.$http.business.updateCustomer(
          params,
          this.type
        );
        if (status === "1") {
          this.$message({
            type: "success",
            message: "操作成功",
            duration: 2000,
          });
          this.$emit("close");
          this.$emit("refreshList");
        }
      } catch (error) {}
    },
    /**
     * @description: 获取业务区域树
     * @Author: yangsibo
     * @Date: 2022-05-12 10:20:36
     */
    async getBusinessZoneList(callback) {
      try {
        let { data } = await this.$http.common.getBusinessZoneList();
        this.businessZoneList = data;
        callback && callback();
      } catch (error) {}
    },
    /**
     * @description: 选中更改后区域
     * @Author: yangsibo
     * @Date: 2022-05-18 08:53:03
     * @param data
     * @param checked
     * @return {*}
     */
    handleOptionClick(data, checked) {
      if (checked) {
        this.node = data;
        this.currentForm.businessPersonId = "";
        this.currentForm.businessZoneId = data.id;
        this.$refs.selectTree.blur();
        this.$nextTick(() => {
          this.$refs.selectedTree.setCurrentKey(this.node.id);
          this.getPersonListbyZoneId(data.id);
        });
      }
    },
    /**
     * @description: 获取业务员列表
     * @Author: yangsibo
     * @Date: 2022-05-12 14:35:20
     * @param {*} id 区域id
     * @return {*}
     */
    async getPersonListbyZoneId(id) {
      try {
        let { data } = await this.$http.business.getPersonListbyZoneId({
          businessZoneId: id,
        });
        this.optionPersonList = data ? data : [];
      } catch (error) {}
    },
  },
  created() {},
  mounted() {
    this.getBusinessZoneList();
  },
  watch: {},
};
</script>
<style lang="scss">
.select-tree {
  max-height: 300px;
  .el-select-dropdown__item,
  .el-select-dropdown__item.selected,
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    font-weight: normal;
    background: #fff;
    padding: 0;
  }
  .el-tree-node.is-current > .el-tree-node__content {
    background: #e1f4f5;
    color: #018388;
  }
  .el-tree-node__content {
    &:hover {
      background: #e1f4f5;
      color: #018388;
    }
  }
}
</style>
<style lang="scss" scoped>
.change-dialog {
  .change-item {
    ::v-deep .el-form-item__content {
      font-size: 16px;
      color: #606266;
      line-height: 40px;
    }
  }
  .foot-btns {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    .btn-cancel {
      width: 100px;
      height: 42px;
      background: #e7eaf0;
      border-radius: 3px;
      font-size: 18px;
      color: #666666;
      border: #666666;
    }
    .btn-confirm {
      width: 100px;
      height: 42px;
      background: #018388;
      border-radius: 3px;
      color: #fff;
      font-size: 18px;
    }
  }
}
</style>
